import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import QueueInputs from './components/QueueInputs';

import { accessLocalStorage, exportCreateQueues, valuesAnalyze, changeViewForms } from '../../../services';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function QueuesCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({
    autofill: 'yes',
    queueEntryVarQueue: 'yes',
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  /*
    {
      name, string
      music, string
      strategy, string
      autofill, string (yes/no) zzz
      maxlen, number
      ringinuse, string (yes/no)
      announcePosition, string (yes/no)
      announceFrequency, number
      announceHoldTime, string (yes/no)
      minAnnounceFrequency, number
      queueEntryVarQueue, string (yes/no)
      wrapuptime, number
      joinempty, string (yes/no/strict)
      leavewhenempty string (yes/no/strict)
    }
  */

  const validateUserLogged = useCallback(() => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar, isNumberNoZero } = valuesAnalyze;

    if(name === 'maxlen' || name === 'announceFrequency' || name === 'minAnnounceFrequency' || name === 'wrapuptime') {
      const checkValueIsNumber = value < 1 ? false : checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    const isNameValue = name === 'name' ? value.toLowerCase() : value;
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = isNameValue )
    if(Object.keys(validate).length >= 12) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataQueueGenerate = async () => {
    const fetchQueues = await exportCreateQueues(values);
    const result = Object.keys(fetchQueues).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-create-queues');
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">ADICIONAR FILA</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article id="success-create-queues" name="success-create-queues" className="column is-half is-offset-one-quarter message is-info is-hidden">
        <div className="message-header">
          <p>Sucesso!</p>
          <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-create-queues') }></button>
        </div>
        <div className="message-body">
          Fila criada com <strong>sucesso</strong>!
        </div>
      </article>
      <div className="columns">
        <div className="column is-fullwidth is-offset-1 has-text-centered">
          <div name="queues-create-div" className="">
            <QueueInputs
              changeValues={handleChangeValues}
            />
          </div>
        </div>
      </div>
      <div id="button-send-form" name="button-send-form" className="columns mt-3">
        <div className="field column mt-3 is-half is-offset-3 has-text-centered">
          <div className="control">
            <button className="button is-info is-fullwidth mt-3" type="submit" disabled={ disable } onClick={ () => sendDataQueueGenerate() }>
              <span className="icon">
                <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
              </span>
              <span>
                Criar Grupo Atendedor
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueuesCreate;
